import {
    POST_DONE,
    POST_ERROR,
    POST_FETCH_DATA,
    POST_PENDING
} from "../actions/postActions";

const initialState = {
    post: {
        done: true,
        data: {
            posts: [],
            totalItems: 0
        },
        error: null
    }
};

const postReducer = (state = initialState, action) => {
    switch (action.type) {
        case POST_FETCH_DATA:
            return {
                ...state,
                post: {
                    ...state.post,
                    data: {posts: action.payload, totalItems: action.payload.length}
                }
            };
        case POST_DONE:
            return {...state, post: {...state.post, done: true, error: null}};
        case POST_PENDING:
            return {...state, post: {...state.post, done: false, error: null}};
        case POST_ERROR:
            return {...state, post: {...state.post, done: true, error: action.payload}};
        default:
            return state;
    }
};

export default postReducer;